export const DEFAULT_WIDTH = 0.56;
const MEASURE_SAFETY_MARGIN = 1.02;

let measureSvg = null;
let measureTextEl = null;

function getMeasureElements() {
  if (!measureSvg) {
    measureSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    measureSvg.style.position = 'absolute';
    measureSvg.style.visibility = 'hidden';
    measureSvg.style.height = '0';
    measureSvg.style.width = '0';
    document.body.appendChild(measureSvg);

    measureTextEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    measureSvg.appendChild(measureTextEl);
  }
  return measureTextEl;
}

export function measureText(text, fontSize, bold = false) {
  const el = getMeasureElements();
  el.setAttribute('font-size', fontSize);
  el.setAttribute('font-family', 'Arial, Helvetica, sans-serif');
  el.setAttribute('font-weight', bold ? 'bold' : 'normal');
  el.textContent = text;

  return el.getBBox().width * MEASURE_SAFETY_MARGIN;
}
